import ships from '@/ships';

const state = {
  currentShip: null,
};

// getters
const getters = {
  currentShip: state => state.currentShip,
  nextShip: (state) => {
      if(state.currentShip + 1 > ships.length) {
          return 0;
      } else {
          return state.currentShip + 1;
      };
  },
  previousShip: (state) => {
      if(state.currentShip - 1 < 0) {
          return ships.length;
      } else {
          return state.currentShip - 1;
      };
  },
  currentShipInformation: state => ships[state.currentShip || 0],
  shipImageLink: (state) => {
      let shipName;
      if(ships[state.currentShip]) {
        shipName = ships[state.currentShip].name;
      } else {
        shipName = 'USS Saratoga';
      }
      let shipLink = '@/../static/images/polaroids/' + shipName.toLowerCase();
      shipLink = shipLink.split(' ').join('-');
      shipLink += '.png';
      if(shipName === 'YO-160') {
          shipLink = '@/../static/images/polaroids/image-unavailable.png';
      }
      return shipLink;
  },
};

// actions
const actions = {
//   setBpm({ commit }, { bpm }) {
//     commit('setBpm', { bpm });
//     store.dispatch('palettes/updateBpm', { bpm });
//   }
};

// mutations
const mutations = {
  setCurrentShip(state, { shipIndex }) {
    state.currentShip = shipIndex;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};


// WEBPACK FOOTER //
// ./store/modules/ships.js